import React from "react";
import { cn } from "../../lib/cn";

export default function WarrantyNotice({ className, tone = "light" }) {
  const light = tone === "light";

  return (
    <aside
      className={cn(
        "rounded-xl px-4 py-3 text-sm leading-relaxed sm:px-5 sm:py-4",
        light
          ? "border border-slate-200 bg-white text-slate-700 shadow-sm"
          : "border border-white/10 bg-slate-950/45 text-slate-300",
        className,
      )}
      role="note"
    >
      <p>Ask us about warranty coverage on eligible repairs.</p>
    </aside>
  );
}
